
export default {
  list: [],
  isUnique: true,
  listCountMessagesChat: [],
  quantidadeDePaginas: 0,
  quantidadeTransacoesAbertas: 0
}



// WEBPACK FOOTER //
// ./src/features/admin/transacoesCompraVenda/store/state.js